module.exports = __webpack_public_path__ + "img/info.b262f1cf.svg";